import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Children, useCallback } from "react";
import { handlerClickMenu } from "../../header.utils";
import { MainContainer, Menu, DropDownContainer, DropDownContent } from "./footer.style";
var Footer = function(param) {
    var menuType = param.menuType, isFirstLevelMenuOpen = param.isFirstLevelMenuOpen, isSecondLevelMenuOpen = param.isSecondLevelMenuOpen, openSecondLevelMenu = param.openSecondLevelMenu;
    var ref, ref1;
    var toggleDropDown = useCallback(function(index) {
        return isSecondLevelMenuOpen.isHovered && index === isSecondLevelMenuOpen.menuIndex;
    }, [
        isSecondLevelMenuOpen
    ]);
    return /*#__PURE__*/ _jsx(MainContainer, {
        children: isFirstLevelMenuOpen.isHovered && /*#__PURE__*/ _jsx(Menu, {
            onMouseLeave: function() {
                openSecondLevelMenu(function(prevData) {
                    return _object_spread_props(_object_spread({}, prevData), {
                        isHovered: false
                    });
                });
            },
            children: Children.toArray((ref = menuType[isFirstLevelMenuOpen.menuIndex]) === null || ref === void 0 ? void 0 : (ref1 = ref.links) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, index) {
                var ref;
                /*#__PURE__*/ return _jsxs("li", {
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            onClick: function(evt) {
                                return handlerClickMenu(evt, item);
                            },
                            className: toggleDropDown(index) ? "hovered" : "",
                            onMouseEnter: function() {
                                openSecondLevelMenu({
                                    menuIndex: index,
                                    isHovered: true
                                });
                            },
                            href: item.url,
                            children: item.category
                        }),
                        toggleDropDown(index) && /*#__PURE__*/ _jsx(DropDownContainer, {
                            children: item === null || item === void 0 ? void 0 : (ref = item.links) === null || ref === void 0 ? void 0 : ref.map(function(elm) {
                                return /*#__PURE__*/ _jsx(DropDownContent, {
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: elm.url,
                                        children: elm.category
                                    })
                                }, elm.id);
                            })
                        })
                    ]
                });
            }))
        })
    });
};
export default Footer;
